import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { checkHasWatchlistApprovers } from '../business-logic/use-cases/CheckHasWatchlistApprovers'
import {
  expenseRepository,
  type ListApprovableExpenseSummaryParams,
} from '../data-access/repositories/ExpenseRepository'

const base = ['expense-approvals']

export const EXPENSE_APPROVAL_LIST_BASE_KEY = [...base, 'list'] as const

export const expenseApprovalQueries = {
  list: (params: ListApprovableExpenseSummaryParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => expenseRepository.listApprovable(params),
  }),
  budgetCheck: (mapping: Record<string, number | null>) => ({
    queryKey: buildQueryKey([...base, 'budget-check', mapping]),
    queryFn: () => expenseRepository.checkBudgetBatch(mapping),
    staleTime: 0,
    cacheTime: 0,
  }),
  hasWatchlistApprovers: () => ({
    queryKey: buildQueryKey([...base, 'watchlist-approver-count']),
    queryFn: () => checkHasWatchlistApprovers(),
  }),
}
